export default __webpack_public_path__ + "static/media/photo-upload.ab99cd43.svg";